import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";
import Datastore from "../../communication/Datastore";

// Define the type for our state store entry
type UrlsState = {};

// Define the initial state for our state store entry
const initialState: UrlsState = {};

// Create a slice to hold all our reducers
const urlsSlice = createSlice({
    name: "urls",
    initialState: initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(REHYDRATE, (_, rawData: any) => {
            if (rawData?.key !== "tts") return undefined;

            return {};
        });
    },
});

export const checkUrl = (url: string): Promise<string[]> => {
    return Datastore.postType<string[]>(`api/SystemIO/UrlCheck`, url);
};

export const getCheckResultMessage = (results: string[]) => {
    return `We detected that this URL is ${results
        .map(getCheckType)
        .join(" and a ")}`;
};

const getCheckType = (type: string) => {
    switch (type) {
        case "MALWARE":
            return "a site hosting malware";
        case "SOCIAL_ENGINEERING":
            return "a phishing site";
        case "UNWANTED_SOFTWARE":
            return "a site hosting unwanted software";
        case "POTENTIALLY_HARMFUL_APPLICATION":
            return "a site hosting a potentially harmful application";
        case "SOCIAL_ENGINEERING_EXTENDED_COVERAGE":
            return "a site hosting social engineering content";
        default:
            return "unsafe content";
    }
};

// We have to export the reducer as this is added to the state store
export default urlsSlice.reducer;
